<template>
  <div>
    <div class="module-lists">
      <ul
        class="list-group"
        v-on:dragover="allowDrop"
        v-on:drop="disableModule"
      >
        <li class="list-group-item disabled">Disabled Modules</li>
        <li
          class="list-group-item"
          v-bind:key="key"
          v-for="(module, key) in modules"
          v-text="module.label"
          draggable="true"
          v-on:drag="drag(module, $event)"
        ></li>
      </ul>
      <ul class="list-group" v-on:dragover="allowDrop" v-on:drop="enableModule">
        <li class="list-group-item disabled">Enabled Modules</li>
        <li
          class="list-group-item"
          v-bind:key="key"
          v-for="(module, key) in enabledModules"
          v-text="module.label"
          draggable="true"
          v-on:drag="drag(module, $event)"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modules: [],
      enabledModules: [],
      draggingKey: null
    };
  },

  mounted() {
    this.getModules();
  },

  methods: {
    moduleWasEnabled(module) {
      this.draggingKey = null;

      let data = {
        module: module.identifier
      };

      window.Ajax.post(
        `/agents/${this.$route.params.identifier}/modules/enable`,
        data
      )
        .then(response => {
          window.toastify.success(
            'Module Enabled',
            'The module was enabled successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was a problem enabling that module, please try again.'
          );
        });
    },

    moduleWasDisabled(module) {
      this.draggingKey = null;

      let data = {
        module: module.identifier
      };

      window.Ajax.post(
        `/agents/${this.$route.params.identifier}/modules/disable`,
        data
      )
        .then(response => {
          window.toastify.success(
            'Module Disabled',
            'The module was disabled successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was a problem disabling that module, please try again.'
          );
        });
    },

    enableModule(event) {
      event.preventDefault();

      let module = this.findModule(this.modules, this.draggingKey);

      this.enabledModules.push(module);

      this.modules = this.refreshModules(this.modules, this.draggingKey);

      this.moduleWasEnabled(module);
    },

    disableModule(event) {
      event.preventDefault();

      let module = this.findModule(this.enabledModules, this.draggingKey);

      this.modules.push(module);

      this.enabledModules = this.refreshModules(
        this.enabledModules,
        this.draggingKey
      );

      this.moduleWasDisabled(module);
    },

    allowDrop(event) {
      event.preventDefault();
    },

    drag(module, event) {
      this.draggingKey = module.identifier;
    },

    getModules() {
      window.Ajax.get(`/modules?agent=${this.$route.params.identifier}`)
        .then(response => {
          this.modules = response.data.disabled;
          this.enabledModules = response.data.enabled;
        })
        .catch(error => {});
    },

    findModule(modules, key) {
      return modules.filter(item => {
        return item.identifier === key;
      })[0];
    },

    refreshModules(modules, key) {
      return modules.filter(item => {
        return item.identifier !== key;
      });
    }
  }
};
</script>
